export default function createRezervaceVytvoreniRequest(values) {
  return {
    datumOd: values.datumOd ? new Date(values.datumOd).getTime() : undefined,
    datumDo: values.datumDo ? new Date(values.datumDo).getTime() : undefined,
    zakaznik: values.zakaznik,
    uzivatel: values.uzivatel,
    projekt: values.projekt,
    zdroj: values.zdroj?.zdroj,
    produkt: values.produkt?.produkt,
    doplnkoveSluzby: values.doplnkoveSluzby,
    poznamka: values.poznamka
  };
}
